// Server-side search across airports + navaids + fixes.
// Replaces the prior client-side dataset download.

export type SearchKind = 'airport' | 'navaid' | 'fix';

export interface SearchHit {
  kind: SearchKind;
  ident: string;
  name: string;
  lat: number;
  lon: number;
  sub?: string;   // city / state / type label
  badge?: string; // 'apt' / 'VOR' / 'fix' / etc.
}

export interface SearchResponse {
  q: string;
  kind: SearchKind | 'all';
  count: number;
  hits: SearchHit[];
}

/** Debounced typeahead. Returns up to `limit` hits across all kinds. */
export async function searchAny(
  q: string,
  options: { kind?: SearchKind; limit?: number; signal?: AbortSignal } = {}
): Promise<SearchHit[]> {
  const norm = q.trim();
  if (!norm) return [];
  const params = new URLSearchParams({ q: norm });
  if (options.kind) params.set('kind', options.kind);
  if (options.limit) params.set('limit', String(options.limit));
  const r = await fetch('/api/search?' + params.toString(), { signal: options.signal });
  if (!r.ok) throw new Error('search HTTP ' + r.status);
  const body = (await r.json()) as SearchResponse;
  return body.hits;
}
